import React from 'react';
import GrammarUnit4Content from './GrammarUnit4Content';
import GrammarUnit5Content from './GrammarUnit5Content';
import GrammarUnit6Content from './GrammarUnit6Content';
import GrammarUnit7Content from './GrammarUnit7Content';
import GrammarUnit8Content from './GrammarUnit8Content';
import GrammarUnit1Content from './GrammarUnit1Content';
import GrammarUnit2Content from './GrammarUnit2Content';
import GrammarUnit9Content from './GrammarUnit9Content';
import GrammarUnit10Content from './GrammarUnit10Content';
import GrammarUnit11Content from './GrammarUnit11Content';
import GrammarUnit12Content from './GrammarUnit12Content';
import GrammarUnit13Content from './GrammarUnit13Content';

const GrammarUnitContent = ({ unit, userPreferences, onMarkComplete, userProgress }) => {
  // Safety check for unit data
  if (!unit || !unit.content) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white p-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-800/30 rounded-xl p-8 text-center">
            <h2 className="text-2xl font-bold mb-4">No Content Available</h2>
            <p className="text-gray-300">Content for this unit is not available.</p>
          </div>
        </div>
      </div>
    );
  }

  // Render specific content based on unit ID
  switch (unit.id) {
    case 1:
      return (
        <GrammarUnit1Content 
          unitData={unit}
          userPreferences={userPreferences}
          onMarkComplete={onMarkComplete}
          userProgress={userProgress}
        />
      );
    case 2:
      return (
        <GrammarUnit2Content 
          unitData={unit}
          userPreferences={userPreferences}
          onMarkComplete={onMarkComplete}
          userProgress={userProgress}
        />
      );
    case 4:
      return (
        <GrammarUnit4Content 
          unitData={unit}
          userPreferences={userPreferences}
          onMarkComplete={onMarkComplete}
          userProgress={userProgress}
        />
      );
    case 5:
      return (
        <GrammarUnit5Content 
          unitData={unit}
          userPreferences={userPreferences}
          onMarkComplete={onMarkComplete}
          userProgress={userProgress}
        />
      );
    case 6:
      return (
        <GrammarUnit6Content 
          unitData={unit}
          userPreferences={userPreferences}
          onMarkComplete={onMarkComplete}
          userProgress={userProgress}
        />
      );
    case 7:
      return (
        <GrammarUnit7Content 
          unitData={unit}
          userPreferences={userPreferences}
          onMarkComplete={onMarkComplete}
          userProgress={userProgress}
        />
      );
    case 8:
      return (
        <GrammarUnit8Content 
          unitData={unit}
          userPreferences={userPreferences}
          onMarkComplete={onMarkComplete}
          userProgress={userProgress}
        />
      );
    case 9:
      return (
        <GrammarUnit9Content 
          unitData={unit}
          userPreferences={userPreferences}
          onMarkComplete={onMarkComplete}
          userProgress={userProgress}
        />
      );
    case 10:
      return (
        <GrammarUnit10Content 
          unitData={unit}
          userPreferences={userPreferences}
          onMarkComplete={onMarkComplete}
          userProgress={userProgress}
        />
      );
    case 11:
      return (
        <GrammarUnit11Content 
          unitData={unit}
          userPreferences={userPreferences}
          onMarkComplete={onMarkComplete}
          userProgress={userProgress}
        />
      );
    case 12:
      return (
        <GrammarUnit12Content 
          unitData={unit}
          userPreferences={userPreferences}
          onMarkComplete={onMarkComplete}
          userProgress={userProgress}
        />
      );
    case 13:
      return (
        <GrammarUnit13Content 
          unitData={unit}
          userPreferences={userPreferences}
          onMarkComplete={onMarkComplete}
          userProgress={userProgress}
        />
      );
    default:
      return (
        <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white p-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gray-800/30 rounded-xl p-8 text-center">
              <h2 className="text-2xl font-bold mb-4">Under Development</h2>
              <p className="text-gray-300">Content for Unit {unit.id} is currently under development.</p>
            </div>
          </div>
        </div>
      );
  }
};

export default GrammarUnitContent;
